import { render, staticRenderFns } from "./BotManageAccess.vue?vue&type=template&id=3fcbac72&"
import script from "./BotManageAccess.vue?vue&type=script&lang=js&"
export * from "./BotManageAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports